import React from 'react';
import { useTranslation } from "react-i18next";
import { Box, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react"


const PurchasingItemsTable = ({data}) => {
    const { t } = useTranslation();

  return (
    <Box
    bg="light" overflow="auto"
    borderRadius={4} boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
  >
    <Table>
      <Thead>
        <Tr>
          <Th>{t("pages.purchases.name")}</Th>
          <Th>{t("pages.purchases.sku")}</Th>
          <Th>{t("pages.purchases.quantity")}</Th>
          <Th>{t("pages.purchases.unit_cost")}</Th>
          <Th>{t("pages.purchases.total_cost")}</Th>
        </Tr>
      </Thead>
      <Tbody>
        {data.map((el, index) => (
          <Tr key={index}>
            <Td>{el?.InventoryItemNameEng}</Td>
            <Td>{"SKU"}</Td>
            <Td>{el?.Quantity}</Td>
            <Td>{el?.UnitCost}</Td>
            <Td>{el?.TotalCost}</Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  </Box>
  );
}

export default PurchasingItemsTable;
